<div class="layout-float-video-player" *ngIf="cameraStream != null">
  <!-- Show PIP video if supported, otherwise show normal floating video -->
  <div *ngIf="hasPictureInPictureSupport" class="pip-video" 
      [style.top]="pipTop" 
      [style.left]="pipLeft"  
      [ngClass]="{'pip-enabled': pipMode}"
    >
    <video #pipVideo [srcObject]="cameraStream" autoplay playsinline [ngClass]="{'pip-enabled': pipMode}"></video>
    <!-- TODO: add mouse hover pointer on the button, put the button over the video. -->
    <div class="pip-video-control-bar">
      <span title="Detached Mode" class="pip-detached" (click)="togglePictureInPicture(pipVideo)">Detached Mode <span class="pip-detached-ico"></span></span>
    </div>
  </div>
  <!-- When pip mode not availbale. we force screen camera view only. -->
  <div *ngIf="!hasPictureInPictureSupport" [style.top]="normalTop" [style.left]="normalLeft" class="normal-video">
    <video [srcObject]="cameraStream" autoplay playsinline ></video>
  </div>
  
</div>

